import { render, staticRenderFns } from "./WaitProExpendPaymentDetail.vue?vue&type=template&id=fe20dba0&"
import script from "./WaitProExpendPaymentDetail.vue?vue&type=script&lang=js&"
export * from "./WaitProExpendPaymentDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaitProExpendPaymentDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports